import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { config } from "./config";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export function useSeo(title, description) {
  const { pathname } = useLocation();
  useEffect(() => {
    const full = title ? `${title} | 学无界 Xue Wujie` : "学无界 Xue Wujie — 让教育没有边界 · Learn Without Borders";
    const desc = description || "让每一个孩子，都有免费学习的机会。Free lessons, an interactive learning world and an open library for every child.";
    const url = `${config.siteUrl}${pathname}`;
    document.title = full;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", desc);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
  }, [title, description, pathname]);
}
